import { create } from "zustand";

export type ErrorCodeType = 401 | 403 | 404 | 500 | null;

interface ErrorStoreType {
  errorCode: ErrorCodeType;
  setErrorCode: (code: ErrorCodeType) => void;
}

const useErrorStore = create<ErrorStoreType>((set) => ({
  errorCode: null,
  setErrorCode: (code: ErrorCodeType) => {
    set({ errorCode: code });
  },
}));

export default useErrorStore;
